import { FC, useEffect } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Button from "components/particles/primary-button";
import { Container, StyledReactModal } from "./style";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { useForm } from "react-hook-form";
import { SessionAmountDTO } from "utils/helpers/models/sessionAmount.dto";
import { useSessionAmount } from "containers/setting/CMS/session-amount/useHook";
import { SessionChargesDTO } from "utils/helpers/models/session-charges.dto";
import { useSettings } from "containers/setting/useHook";
interface AddSessionAmountModelProps {
  data: any;
  setData: Function
}

const AddSessionChargesPopup: FC<AddSessionAmountModelProps> = ({
  data,
  setData
}) => {
  const { register, handleSubmit, setValue } = useForm<SessionChargesDTO>();
  // const { postSessionAmount, putSessionAmount } = useSessionAmount();
  const { postSessionCharges, getSessionCharges } = useSettings();

  const { sessionAmountModalIsOpen } = useSelector((state: any) => state.user);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      borderRadius: "3rem",
    },
  };
  function closeModal() {
    dispatch(setModalClosed("Session Amount"));
  }

  const submit = (formData: SessionChargesDTO) => {
    const payload = {
      adminCharges: Number(formData.adminCharges),
      homeCookPenaltyFee: Number(formData.homeCookPenaltyFee),
    };

    postSessionCharges(payload).then(() => {
      closeModal();
      getSessionCharges(setData)
    });
  };


  // useEffect(() => {
  //   if (data) {
  //     setValue("adminCharges", data.amount);
  //   }
  // }, [data]);
  useEffect(() => {
    if (data) {
      setValue("adminCharges", data.adminCharges);
      setValue("homeCookPenaltyFee", data.homeCookPenaltyFee);
    }
  }, [data]);


  return (
    <StyledReactModal
      isOpen={sessionAmountModalIsOpen}
      onRequestClose={closeModal}
      // style={customStyles}
      contentLabel="Example Modal"
    >
      <Container>
        <button className="close-button" onClick={closeModal}>
          <img src={close} alt="img" />
        </button>
        <div className="model-container">
          <div className="popup-title">
            <h1>
              Session Charge
            </h1>
          </div>
          <div className="add-ingredient-container">
            <div>
              <label htmlFor="adminCharges">Admin Charge's</label>
            </div>
            <input
              id="adminCharges"
              type="number"
              step="0.01"
              placeholder="Admin Charges"
              {...register("adminCharges", { required: true })}
            />
            <div>
              <label htmlFor="adminCharges">Home Cook Penalty </label>
            </div>
            <input
              type="number"
              step="0.01"
              placeholder="Home Cook Penalty Fee"
              {...register("homeCookPenaltyFee", { required: true })}
            />

          </div>

          <div className="add-button">
            <Button
              title={"Submit"}
              width="51.2rem"
              backgroundcolor="var(--primary)"
              fill="true"
              onclick={handleSubmit(submit)}
            />
          </div>
        </div>
      </Container>
    </StyledReactModal>
  );
};

export default AddSessionChargesPopup;
